import { useNavigate, type NavigateFunction } from "react-router-dom";
import { authSession } from "@/features/auth";

/** Ends an explicit portal session without carrying that portal into the next login's return destination. */
export function logoutPortalSession(navigate: NavigateFunction) {
  authSession.clearSession();
  // The eager public home route leaves the guard immediately, even while the login chunk loads.
  // Home then opens a fresh login; genuine unauthenticated deep links still retain their return path.
  void navigate("/", { replace: true, state: null, flushSync: true });
}

/** Gives portal shells one logout action while keeping session invalidation in auth's public contract. */
export function usePortalLogout() {
  const navigate = useNavigate();
  return () => logoutPortalSession(navigate);
}
